"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vue = require("vue");

var _xeUtils = _interopRequireDefault(require("xe-utils"));

var _tools = require("../../tools");

var _vXETable = require("../../v-x-e-table");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toFilters = _tools.UtilTools.toFilters;
var tableFilterMethodKeys = ['setFilter', 'clearFilter', 'getCheckedFilters'];
var tableFilterHook = {
  setupTable: function setupTable($xetable) {
    var reactData = $xetable.reactData,
        internalData = $xetable.internalData;

    var _$xetable$getRefMaps = $xetable.getRefMaps(),
        refTableBody = _$xetable$getRefMaps.refTableBody,
        refTableFilter = _$xetable$getRefMaps.refTableFilter;

    var _$xetable$getComputeM = $xetable.getComputeMaps(),
        computeFilterOpts = _$xetable$getComputeM.computeFilterOpts;

    var filterPrivateMethods = {
      checkFilterOptions: function checkFilterOptions() {
        var filterStore = reactData.filterStore;
        filterStore.isAllSelected = filterStore.options.every(function (item) {
          return item._checked;
        });
        filterStore.isIndeterminate = !filterStore.isAllSelected && filterStore.options.some(function (item) {
          return item._checked;
        });
      },

      /**
       * 点击筛选事件
       * 当筛选图标被点击时触发
       * 更新选项是否全部状态
       * 打开筛选面板
       * @param {Event} evnt 事件
       * @param {ColumnInfo} column 列配置
       * @param {Object} params 参数
       */
      triggerFilterEvent: function triggerFilterEvent(evnt, column, params) {
        var initStore = reactData.initStore,
            filterStore = reactData.filterStore;

        if (filterStore.column === column && filterStore.visible) {
          filterStore.visible = false;
        } else {
          var targetElem = evnt.target,
              pageX = evnt.pageX;

          var _DomTools$getDomNode = _tools.DomTools.getDomNode(),
              visibleWidth = _DomTools$getDomNode.visibleWidth;

          var filters = column.filters,
              filterMultiple = column.filterMultiple,
              filterRender = column.filterRender;
          var compConf = filterRender ? _vXETable.VXETable.renderer.get(filterRender.name) : null;
          var filterRecoverMethod = column.filterRecoverMethod || (compConf ? compConf.filterRecoverMethod : null);
          internalData._currFilterParams = params;
          Object.assign(filterStore, {
            multiple: filterMultiple,
            options: filters,
            column: column,
            style: null
          }); // 复原状态

          filterStore.options.forEach(function (option) {
            var _checked = option._checked,
                checked = option.checked;
            option._checked = checked;

            if (!checked && _checked !== checked) {
              if (filterRecoverMethod) {
                filterRecoverMethod({
                  option: option,
                  column: column,
                  $table: $xetable
                });
              }
            }
          });
          this.checkFilterOptions();
          filterStore.visible = true;
          initStore.filter = true;
          (0, _vue.nextTick)(function () {
            var tableBody = refTableBody.value;
            var bodyElem = tableBody.$el;
            var tableFilter = refTableFilter.value;
            var filterWrapperElem = tableFilter ? tableFilter.$el : null;
            var filterWidth = filterWrapperElem ? filterWrapperElem.offsetWidth : 0;
            var centerWidth = filterWidth / 2;
            var minMargin = 32;
            var left, right;
            var style = {
              top: "".concat(targetElem.offsetTop + targetElem.offsetParent.offsetTop + targetElem.offsetHeight + 8, "px")
            };

            if (column.fixed === 'left') {
              left = targetElem.offsetLeft + targetElem.offsetParent.offsetLeft - centerWidth;
            } else if (column.fixed === 'right') {
              right = targetElem.offsetParent.offsetWidth - targetElem.offsetLeft + (targetElem.offsetParent.offsetParent.offsetWidth - targetElem.offsetParent.offsetLeft) - column.renderWidth - centerWidth;
            } else {
              left = targetElem.offsetLeft + targetElem.offsetParent.offsetLeft - centerWidth - bodyElem.scrollLeft;
            }

            if (left) {
              var overflowWidth = pageX + filterWidth - centerWidth + minMargin - visibleWidth;

              if (overflowWidth > 0) {
                left -= overflowWidth;
              }

              style.left = "".concat(Math.max(minMargin, left), "px");
            } else if (right) {
              var _overflowWidth = pageX + filterWidth - centerWidth + minMargin - visibleWidth;

              if (_overflowWidth > 0) {
                right += _overflowWidth;
              }

              style.right = "".concat(right, "px");
            }

            filterStore.style = style;
          });
        }
      },
      handleClearFilter: function handleClearFilter(column) {
        if (column) {
          var filters = column.filters,
              filterRender = column.filterRender;

          if (filters) {
            var compConf = filterRender ? _vXETable.VXETable.renderer.get(filterRender.name) : null;
            var filterResetMethod = column.filterResetMethod || (compConf ? compConf.filterResetMethod : null);
            filters.forEach(function (item) {
              item._checked = false;
              item.checked = false;

              if (!filterResetMethod) {
                item.data = _xeUtils.default.clone(item.resetValue, true);
              }
            });

            if (filterResetMethod) {
              filterResetMethod({
                options: filters,
                column: column,
                $table: $xetable
              });
            }
          }
        }
      }
    };
    var filterMethods = {
      /**
       * 修改筛选条件列表
       * @param {ColumnInfo} fieldOrColumn 列或字段名
       * @param {Array} options 选项
       */
      setFilter: function setFilter(fieldOrColumn, options) {
        var column = $xetable.handleFieldOrColumn(fieldOrColumn);

        if (column && column.filters && options) {
          column.filters = toFilters(options);
        }

        return (0, _vue.nextTick)();
      },

      /**
       * 清空指定列的筛选条件
       * 如果为空则清空所有列的筛选条件
       * @param {String} fieldOrColumn 列或字段名
       */
      clearFilter: function clearFilter(fieldOrColumn) {
        var filterStore = reactData.filterStore;
        var tableFullColumn = internalData.tableFullColumn;
        var filterOpts = computeFilterOpts.value;
        var column;

        if (fieldOrColumn) {
          column = $xetable.handleFieldOrColumn(fieldOrColumn);

          if (column) {
            filterPrivateMethods.handleClearFilter(column);
          }
        } else {
          tableFullColumn.forEach(filterPrivateMethods.handleClearFilter);
        }

        if (!fieldOrColumn || column !== filterStore.column) {
          Object.assign(filterStore, {
            isAllSelected: false,
            isIndeterminate: false,
            style: null,
            options: [],
            column: null,
            multiple: false,
            visible: false
          });
        }

        if (!filterOpts.remote) {
          return $xetable.updateData();
        }

        return (0, _vue.nextTick)();
      },
      getCheckedFilters: function getCheckedFilters() {
        var visibleColumn = internalData.visibleColumn;
        var filterList = [];
        visibleColumn.filter(function (column) {
          var property = column.property,
              filters = column.filters;
          var valueList = [];
          var dataList = [];

          if (filters && filters.length) {
            filters.forEach(function (item) {
              if (item.checked) {
                valueList.push(item.value);
                dataList.push(item.data);
              }
            });

            if (valueList.length) {
              filterList.push({
                column: column,
                property: property,
                values: valueList,
                datas: dataList
              });
            }
          }
        });
        return filterList;
      }
    };
    return _objectSpread(_objectSpread({}, filterMethods), filterPrivateMethods);
  },
  setupGrid: function setupGrid($xegrid) {
    return $xegrid.extendTableMethods(tableFilterMethodKeys);
  }
};
var _default = tableFilterHook;
exports.default = _default;